import Reveal from "@/components/base/Reveal";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  text?: string;
  align?: "left" | "center";
}

export default function SectionHeading({ eyebrow, title, text, align = "center" }: SectionHeadingProps) {
  const alignment = align === "center" ? "items-center text-center" : "items-start text-left";

  return (
    <Reveal className={`flex flex-col ${alignment}`}>
      {eyebrow ? (
        <span className="mb-4 flex items-center gap-2 text-[11px] uppercase tracking-[0.28em] text-accent-700">
          <span className="flex h-3 w-3 items-center justify-center">
            <i className="ri-leaf-line text-[11px]" />
          </span>
          {eyebrow}
        </span>
      ) : null}
      <h2 className="max-w-2xl font-heading text-3xl font-medium leading-tight text-foreground-900 md:text-4xl">
        {title}
      </h2>
      {text ? (
        <p className={`mt-4 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base ${align === "center" ? "mx-auto" : ""}`}>
          {text}
        </p>
      ) : null}
    </Reveal>
  );
}